import * as React from 'react';
import { BaseTabActivator } from './BaseTabActivator';
import { TabsWidget } from './TabsWidget';

/**
 * Manually activated tabs: users activate a tab and display its panel by pressing space or enter
 */

export class ManualTabActivator extends BaseTabActivator {
  public constructor(tabsWidget: TabsWidget) {
    super(tabsWidget);
  }

  public handleKeyDown(tabIndex: number, keyboardEvent: React.KeyboardEvent<HTMLDivElement>): void {
    // Check to see if we should focus a tab (but not change which tab panel is being displayed)
    const tabIndexToFocus = this.tabIndexFromKeyDown(tabIndex, keyboardEvent.key);
    if (tabIndexToFocus !== -1) {
      this.tabsWidget.setFocusedIndex(tabIndexToFocus);
      BaseTabActivator.preventDefaultAndStopPropagation(keyboardEvent);
      return;
    }

    // Check to see if we should activate a tab (which would display its corresponding tab panel)
    const tabIndexToActivate = this.tabIndexToActivate(keyboardEvent.key);
    if (tabIndexToActivate !== -1) {
      this.tabsWidget.setActiveIndex(tabIndexToActivate);
      BaseTabActivator.preventDefaultAndStopPropagation(keyboardEvent);
    }
  }

  private tabIndexToActivate(keyValue: string): number {
    switch (keyValue) {
      case 'Enter':
      case ' ':
        return this.tabsWidget.state.focusedIndex;
      default:
        return -1;
    }
  }
}
